module.exports = __webpack_public_path__ + "img/cases-brand-herborist-8.a69cc4c2.jpg";